module.exports = __webpack_public_path__ + "img/img17.61863a02.svg";